module.exports = __webpack_public_path__ + "img/homeEdition.9e849fc2.png";